import { baseRoute } from '../../../../constants/routes';

export const PRIZES_ROUTE = baseRoute + '/prize';

export const CREATE_PRIZE = 'CREATE_PRIZE';
export const CREATE_PRIZE_SUCCESS = 'CREATE_PRIZE_SUCCESS';

export const GET_PRIZES = 'GET_PRIZES';
export const GET_PRIZES_SUCCESS = 'GET_PRIZES_SUCCESS';

export const UPDATE_PRIZE = 'UPDATE_PRIZE';
export const UPDATE_PRIZE_SUCCESS = 'UPDATE_PRIZE_SUCCESS';

export const DELETE_PRIZE = 'DELETE_PRIZE';
export const DELETE_PRIZE_SUCCESS = 'DELETE_PRIZE_SUCCESS';